import { getEnvVar } from '../envUtils.ts';
import ApiService from "./ApiService";

/*
 * ⚠️ API VERSIONING NOTE:
 * This service uses multiple backend API versions. DO NOT change paths without backend team confirmation.
 *   - Legacy scenario APIs:      test/{missionId}/scenario/...
 *   - V2 scenario listing/undeploy: v2/simulate/{missionId}/scenario/...
 *   - V3 manual scenario APIs:   v3/simulate/{missionId}/scenario/...
 *   - V3 grafana (legacy prefix): test/v3/{missionId}/scenario/...  ← TODO: Confirm with backend if this should be v3/simulate/
 */

const getALLScenarios = (missionId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v2/simulate/${missionId}/scenario`);
}
const getALLScenariosOrchestrate = (missionId) => {
    return ApiService.get(
        `${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v2/simulate/${missionId}/scenario?scenarioOperation=CONOPS`
    );
};

const createScenario = (missionId, data) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario`, data);
}

const createManualScenario = (missionId, data) => {
    return ApiService.uploadFormData(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v3/simulate/${missionId}/scenario`, data);
}

const deployManualScenario = (missionId, scenarioId) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v3/simulate/${missionId}/scenario/${scenarioId}/deploy`);
}

const getManualScenario = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v3/simulate/${missionId}/scenario/${scenarioId}/deploymentdetails`,);
}

const getGrafanaDataForManualScenario = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/v3/${missionId}/scenario/${scenarioId}/grafana`);
}

const getVisualizationElements = (missionId, scenarioId, compression = 'gzip') => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v3/simulate/${missionId}/scenario/${scenarioId}/elements/visualization?compression=${compression}`);
}


const patchScenarioName = (missionId, scenario_id, data) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenario_id}/updateScenarioConfig`, data);
}

const getScenario = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}`);
}

const updateScenarioWithSatelliteGroups = (missionId, scenarioId, data) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/addSatelliteGroups`, data);
}

const updateScenarioWithExternalOrbits = (missionId, scenarioId, data) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/external`, data);
}

const updateScenarioWithGroundStations = (missionId, scenarioId, data) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/addGroundStations`, data);
}

const deleteScenario = (missionId, scenarioId) => {
    return ApiService.delete(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}`);
}

const cloneScenario = (missionId, scenarioId) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/clone?missionId=${missionId}&scenarioId=${scenarioId}`);
}

const generateSchedule = (missionId, scenarioId, path, body) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/generateonboardschedule?${path}`, body);
}

const generateImportedSchedule = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/getonboardschedule`);
}

/////////////////////GET SATELLITE GROUPS/////////////////////
const getSatelliteGroups = (missionId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}mission/${missionId}/satelliteGroup`);
}
/////////////////////GET SATELLITE GROUPS/////////////////////

const deployScenario = (missionId, scenarioId) => {
    // Deploying scenario
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v1/simulate/${missionId}/scenario/${scenarioId}/deployment`);
}

const quickDeploy = (missionId, scenarioId, data) => {
    // Deploying scenario
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/truetwin/deployment`, data);
}

const getAllScenarioDeploymentInfo = (missionId, scenarioId) => {
    // Getting Al Infor Of Deploying scenario
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/deploymentdetails`);
}

const getAllTaskPlansInScenario = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/getTaskPlans`);
}

const unDeployScenario = (missionId, scenarioId) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/undeployment`);
}

const postGrafanaData = (scenarioId, missionId, remotePayloadName) => {
    if (typeof remotePayloadName != 'undefined') {
        return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/grafana?missionId=${missionId}&remotePayloadName=${remotePayloadName}`);
    }
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/grafana?missionId=${missionId}`);

}

const getGrafanaData = (scenarioId, missionId, satelliteGroupId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/${scenarioId}/grafana?missionId=${missionId}&satelliteGroupId=${satelliteGroupId}`);
}

const getScenarioInfoByGroupId = (scenarioId, missionId, satelliteGroupId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/satelliteGroupId/${satelliteGroupId}/deploymentdetails`);
}

const exportSchedule = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/exportschedule`);
}

const importSchedule = (missionId, scenarioId, file_data, scenario_start_time, duration) => {
    return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/importschedule?simulationStartTime=${scenario_start_time}&simulationDuration=${duration}`, file_data);
}

const getTrueTwinDetails = (trueTwinId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/truetwin/${trueTwinId}`);
}

const postPredictionData = (missionId, scenarioId, satelliteGroupId, satelliteId, fidelity, scheduleId) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/prediction?scheduleId=${scheduleId}&mode=1&satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}&fidelity=${fidelity}`);
}

const getPredictionData = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/prediction`);
}

const getPredictionOrbitOrientationData = (missionId, scenarioId, satelliteGroupId, satelliteId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/prediction/visualizationreport?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`);
}

const getHeatMapReport = (missionId, scenarioId, satelliteGroupId, satelliteId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/prediction/thermalvisualizationreport?satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`);
}

const addInitialAttutudeCondition = (missionId, scenarioId, body) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/initalAttitudeConditions`, body);
}

const addInitialAttitudeCondition = (missionId, scenarioId, body) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/initalAttitudeConditions`, body);
}

const generateLeOpsSchedule = (missionId, scenarioId, path, body) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/addEpochDurationInLeOps?${path}`, body);
}

const importThermalTelemetry = (missionId, satelliteId, scenarioId, file_data) => {
    return ApiService.upload(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/telemetry/zipFileUpload?missionId=${missionId}&satelliteId=${satelliteId}&scenarioId=${scenarioId}`, file_data);
}

const exportThermalDataFile = (missionId, scenarioId, satelliteGroupId, satelliteId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/prediction/export?missionId=${missionId}&scenarioId=${scenarioId}&satelliteGroupId=${satelliteGroupId}&satelliteId=${satelliteId}`);
}
const reDeployRemotePayloadScenario = ((missionId, scenarioId, data) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/redeployment`, data);
})

const getHWILComponents = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/getHwilDevices?missionId=${missionId}&scenarioId=${scenarioId}`);
}

const updateHWILConfiguration = (missionId, scenarioId, data) => {
    return ApiService.patch(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/updateScenarioHwil`, data);
}
const generateHwilConfigFile = (missionId, scenarioId) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/generateConfigHwil`);
}
const downloadHwilConfigFile = (missionId, scenarioId, fileId, credentials) => {
    return (`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/hwilFileDownload?missionId=${missionId}&scenarioId=${scenarioId}&uniqueId=${fileId}&authToken=${credentials}`);
}

const exportTelemetry = (missionId, scenarioId, credentials) => {
    return (`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/exportTelemetry?missionId=${missionId}&scenarioId=${scenarioId}&authToken=${credentials}`);
}

const exportTelemetryBySatellite = (missionId, scenarioId, satId, credentials) => {
    return (`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/scenario/exportTelemetry?missionId=${missionId}&scenarioId=${scenarioId}&satelliteId=${satId}&authToken=${credentials}`);
}

const getHwilConnectStatus = (missionId, scenarioId, reconnect) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/hwilConnectStatus?reconnect=${reconnect}`);
}

const hwilSimulationStart = (missionId, scenarioId) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/hwilsimstart`);
}

const getOrbitalInsights = (missionId, scenarioId) => {
    return ApiService.get(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}test/${missionId}/scenario/${scenarioId}/orbitalInsights`);
}

const unDeployManualScenario = (missionId, scenarioId) => {
    return ApiService.post(`${getEnvVar('REACT_APP_BACKEND_BASE_URL')}v2/simulate/${missionId}/scenario/${scenarioId}/undeploy`);
}

const SimulateService = {
    getALLScenarios,
    createScenario,
    createManualScenario,
    deployManualScenario,
    getManualScenario,
    patchScenarioName,
    getScenario,
    deleteScenario,
    cloneScenario,
    generateSchedule,
    updateScenarioWithSatelliteGroups,
    updateScenarioWithGroundStations,
    generateLeOpsSchedule,

    /////////////////////GET SATELLITE GROUPS/////////////////////
    getSatelliteGroups,
    /////////////////////GET SATELLITE GROUPS/////////////////////
    quickDeploy,
    deployScenario,
    postPredictionData,
    getPredictionData,
    getPredictionOrbitOrientationData,
    getHeatMapReport,
    getAllScenarioDeploymentInfo,
    getAllTaskPlansInScenario,
    unDeployScenario,
    unDeployManualScenario,
    postGrafanaData,
    getGrafanaData,
    getGrafanaDataForManualScenario,
    getVisualizationElements,
    getScenarioInfoByGroupId,
    exportSchedule,
    importSchedule,
    generateImportedSchedule,
    importThermalTelemetry,
    exportThermalDataFile,

    exportTelemetry,
    exportTelemetryBySatellite,

    getOrbitalInsights,

    //////////////////////GET TRUETWIN DETAILS/////////////////////
    getTrueTwinDetails,
    addInitialAttitudeCondition,

    ////////////////////REDEPLOY SCENARIO/////////////////////
    reDeployRemotePayloadScenario,
    getHWILComponents,
    updateHWILConfiguration,
    generateHwilConfigFile,
    downloadHwilConfigFile,
    getHwilConnectStatus,
    hwilSimulationStart,
    getALLScenariosOrchestrate

}

export default SimulateService;